import React from 'react';
import moment from 'moment';
import DatePicker from 'react-date-picker';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import useReportDates from '../../../hooks/useReportDates';

function UserDatePickers() {
  const { dates, changeDates } = useReportDates();

  function onStartChange(val) {
    changeDates({
      type: 'user',
      payload: {
        start: moment(val).startOf('day').toDate()
      }
    });
  }

  function onEndChange(val) {
    changeDates({
      type: 'user',
      payload: {
        end: moment(val).endOf('day').toDate()
      }
    });
  }

  return (
    <Row className="justify-content-center mb-1">
      <Col md={{ span: 'auto', offset: 'auto' }}>
        <span>Start: </span>
        <DatePicker
          calendarIcon={null}
          clearIcon={null}
          value={dates.user.start}
          onChange={onStartChange}
          locale="en-US"
        />
      </Col>
      <Col md={{ span: 'auto', offset: 'auto' }}>
        <span>End: </span>
        <DatePicker
          calendarIcon={null}
          clearIcon={null}
          value={dates.user.end}
          onChange={onEndChange}
          locale="en-US"
        />
      </Col>
    </Row>
  );
}

export default UserDatePickers;
